export const I18N_CONSTANTS = Object.freeze({
  DEFAULT_LANGUAGE: 'en',
  LOCALE_STORAGE_KEY_NAME: 'language',
  AVAILABLE_LANGUAGES: [
    {
      lang: 'en'
    }
  ]
})
